import React from 'react'
import { ResponsiveLine } from '@nivo/line'

export const CardLineChart = ({ usersInTime }) => {
    return (
        <div className='w-full  h-full '>
            <MyResponsiveLine data={usersInTime} />
        </div>
    )
}


const MyResponsiveLine = ({ data = [
    {
        "id": "japan",
        "color": "hsl(84, 70%, 50%)",
        "data": [
            {
                "x": "plane",
                "y": 2
            },
            {
                "x": "car",
                "y": 4
            },
            {
                "x": "moto",
                "y": 4
            },
            {
                "x": "horse",
                "y": 8
            },
            {
                "x": "skateboard",
                "y": 10
            },
            {
                "x": "ohers",
                "y": 12
            }
        ]
    },
]/* see data tab */ }) => (
    <ResponsiveLine
        data={data}
        margin={{ top: 10, right: 50, bottom: 30, left: 50 }}
        xScale={{ type: 'point' }}
        yScale={{
            type: 'linear',
            min: 'auto',
            max: 'auto',
            stacked: true,
            reverse: false
        }}
        yFormat=" >-.2f"
        axisTop={null}
        axisRight={null}
        // axisBottom={{
        //     orient: 'bottom',
        //     tickSize: 5,
        //     tickPadding: 5,
        //     tickRotation: 0,
        //     legend: '',
        //     legendOffset: 36,
        //     legendPosition: 'middle'
        // }}
        // axisLeft={{
        //     orient: 'left',
        //     tickSize: 5,
        //     tickPadding: 5,
        //     tickRotation: 0,
        //     legend: 'Usuarios',
        //     legendOffset: -40,
        //     legendPosition: 'middle'
        // }}
        pointSize={10}
        pointColor="#ff0000"
        pointBorderWidth={5}
        pointBorderColor="#fd6d6d"
        colors={{ scheme: 'category10' }}

        lineWidth={4}
        pointLabelYOffset={-12}
        useMesh={true}

    />
)

export default CardLineChart